import React from 'react';
import { AppRouteProps } from '~/routes';
import Index from './pages';
import Create from './pages/create';
import Edit from './pages/edit';

export default function AreaRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    { path: '/area', component: Index, isProtected: true, permissions: ['area_index'] },
    { path: '/area/create', component: Create, isProtected: true, permissions: ['area_create'] },
    { path: '/area/edit/:id', component: Edit, isProtected: true , permissions: ['area_edit']},
  ];

  return routes;
}
